import { useQuery } from '@tanstack/react-query';
import { get } from '../api/client.js';

export function useStubs() {
  return useQuery({
    queryKey: ['me', 'stubs'],
    queryFn: async () => (await get('/api/me/stubs')).stubs || [],
    staleTime: 60_000,
  });
}
